import { getDictionaryApi } from '@/api/common/public'

/**
 * 判断手机号灰度开关是否打开
 * @param res
 * @param phoneCodeVal
 * @returns {boolean}
 */
export async function isEnableSdkTel(phoneCodeVal, cb) {
  let isEnableSdk = false
  try {
    const response = await getDictionaryApi({ name: 'slide_gray_icas', lang: 'zh-CN' })
    for (const key in response.data) {
      if (key.toLocaleLowerCase() === 'all' || (phoneCodeVal.indexOf(key) !== -1 && response.data[key] === 'true')) {
        isEnableSdk = true
        break
      }
    }
    cb && cb(isEnableSdk)
  } catch (error) {
    cb && cb(isEnableSdk)
  }
  return isEnableSdk
}

export async function isEnableSdk(cb) {
  let isEnableSdk = false
  try {
    const response = await getDictionaryApi({ name: 'slide_gray_common', lang: 'zh-CN' })
    for (const key in response.data) {
      if (key.toLocaleLowerCase() === 'all' || (key === 'icas')) {
        isEnableSdk = true
        break
      }
    }
    cb && cb(isEnableSdk)
  } catch (error) {
    cb && cb(isEnableSdk)
  }
  console.log('isEnableSdk', isEnableSdk)
  return isEnableSdk
}

/**
 * 判断邮箱灰度开关是否打开
 * @param res
 * @param phoneCodeVal
 * @returns {boolean}
 */
export async function isEnableSdkMail(cb) {
  let isEnableSdk = false
  const systemCode = 'icas'
  try {
    const response = await getDictionaryApi({ name: 'slide_gray_email_syscode', lang: 'zh-CN' })
    isEnableSdk = response.data.enable

    for (const key in response.data) {
      if (key.toLocaleLowerCase() === 'all' || (systemCode.indexOf(key) !== -1 && response.data[systemCode] === 'true')) {
        isEnableSdk = true
        break
      }
    }

    cb && cb(isEnableSdk)
  } catch (error) {
    cb && cb(isEnableSdk)
  }
}
